<template>
  <div class="status-widget">
    <RBadge v-if="badge" class="status-badge" :class="status.toLowerCase()">
      {{ status }}
    </RBadge>
    <template v-else>
      <CIcon name="md-circle" :class="status.toLowerCase()" height="10" />
      <div>
        {{ status }}
        <div v-if="date" class="date">
          {{ date }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { RBadge } from '@/components/badges'

/**
 * Widget to display a property's status.
 */
const STATUSES = [
  'inactive', 'active', 'trial', 'pre-trial', 'onboarding',
  'offboarding', 'pending', 'invalid', 'auto-created'
]

export default {
  name: 'RWidgetStatus',
  components: {
    RBadge
  },
  props: {
    status: {
      type: String,
      required: true,
      validator: value => {
        return STATUSES.includes(value.toLowerCase())
      }
    },
    date: {
      type: String,
      default: ''
    },
    badge: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.status-widget {
  display: flex;
  align-items: baseline;
  color: $dark;
  text-transform: capitalize;
  .status-badge {
    font-size: 1rem;
    color: $white;
    &.inactive {
      background-color: $secondary-25;
    }
    &.active {
      background-color: $success;
    }
    &.trial {
      background-color: $primary;
    }
    &.pre-trial {
      background-color: $gray-700;
    }
    &.onboarding {
      background-color: $info;
    }
    &.offboarding {
      background-color: $danger;
    }
    &.pending {
      background-color: $warning;
    }
    &.auto-created {
      background-color: $info;
    }
  }
  .date {
    color: $gray-700;
    font-size: 0.8em;
  }
  .c-icon {
    margin: 10px;
    &.inactive {
      color: $secondary-25;
    }
    &.active {
      color: $success;
    }
    &.trial {
      color: $primary;
    }
    &.pre-trial {
      color: $gray-700;
    }
    &.onboarding {
      color: $info;
    }
    &.offboarding {
      color: $danger;
    }
    &.pending {
      color: $warning;
    }
    &.auto-created {
      color: $info;
    }
  }
}
</style>
